// extracted by mini-css-extract-plugin
module.exports =  {"container":"_025a50318d--container--NfE9t","links":"_025a50318d--links--m97tp"};